import React from 'react';
import PageMeta from '../components/common/PageMeta';

import TrialBanner from "../components/trial/trialbanner";
import FooterOne from '../layout/Footer/FooterOne';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import HeroEightCustom from './HeroEightCustom';



const HomeAppTwo = () => {
    const inlineCodeStyle = {
        backgroundColor: '#f5f5f5',
        fontFamily: 'monospace',
        fontSize: '0.95em',
        padding: '2px 4px',
        borderRadius: '4px',
        color: '#c7254e',
        border: '1px solid #e1e1e8',

    };

    const codeLines = [
        'import paramiko',
        '',
        'client = paramiko.SSHClient()',
        'client.set_missing_host_key_policy(paramiko.AutoAddPolicy())',
        '',
        "client.connect(hostname='example.com', username='user', password='pass')",
        'sftp = client.open_sftp()',
        'print("Connected")',
        'sftp.close()',
        'client.close()',
    ];

    const codeLinesDos = [
        "import paramiko",
        "",
        "hostname = 'sftp.example.com'",
        "port = 22",
        "username = 'your_username'",
        "key_path = '/path/to/private_key.pem'",
        "",
        "key = paramiko.RSAKey.from_private_key_file(key_path)",
        "",
        "client = paramiko.SSHClient()",
        "client.set_missing_host_key_policy(paramiko.AutoAddPolicy())",
        "",
        "try:",
        "    client.connect(hostname, port=port, username=username, pkey=key)",
        "    sftp = client.open_sftp()",
        "    print(\"Connection successful with SSH key!\")",
        "",
        "    # List files in remote directory",
        "    for filename in sftp.listdir('.'):",
        "        print(filename)",
        "",
        "    sftp.close()",
        "finally:",
        "    client.close()"
    ];


    return (
        <Layout>
            <PageMeta title='How to Connect to an SFTP Server Using Python | FilePulse' description="Complete guide on the difference between MFT and ELT/ETL." />
            <Navbar navDark />
            <HeroEightCustom>
                How to Connect to an SFTP Server Using Python
            </HeroEightCustom>
            <section className='blog-details ptb-120'>
                <div className='container'>
                    <div className='row justify-content-between'>
                        <div className='col-lg-9 pe-5'>
                            <div className='blog-details-wrap'>

                                <p>SFTP (SSH File Transfer Protocol) is a secure file transfer protocol that operates over SSH. It’s a reliable way to upload, download, and manage files on a remote server. In this blog post, we’ll walk through how to connect to an SFTP server using Python, and explain the difference between authenticating with a password and an SSH key.</p>

                                <h4>Prerequisites</h4>
                                <ul>
                                    <li>Python 3.x installed</li>
                                    <li>The <code>paramiko</code> library installed (<code>pip install paramiko</code>)</li>
                                    <li>Access to an SFTP server (hostname, username, and either a password or private SSH key)</li>
                                </ul>

                                <h4>Installing Paramiko</h4>
                                <p>Paramiko is a Python implementation of the SSHv2 protocol that allows you to programmatically connect and interact with SSH/SFTP servers.</p>

                                <pre style={inlineCodeStyle}><code>pip install paramiko</code></pre>

                                <h4>1. Connecting Using a Password</h4>
                                <p>This approach relies on basic credential-based authentication, where access to the server is granted by verifying a username and password combination. It's simple to set up but generally offers less security compared to key-based methods.</p>

                                <pre style={inlineCodeStyle}>
                                    <code>
                                        {codeLines.map((line, index) => (
                                            <div key={index}>{line}</div>
                                        ))}
                                    </code>
                                </pre>


                                <h4>2. Connecting Using an SSH Key</h4>
                                <p>Using an SSH key for authentication is generally considered more secure than traditional password-based methods. SSH key authentication uses a cryptographic key pair—comprising a private key (kept secure by the user) and a public key (shared with the server)—to
                                    establish trust and grant access. This method is especially well-suited for automated systems, such as continuous integration/continuous deployment (CI/CD) pipelines.
                                </p>

                                <pre style={inlineCodeStyle}>
                                    <code>
                                        {codeLinesDos.map((line, index) => (
                                            <div key={index}>{line}</div>
                                        ))}
                                    </code>
                                </pre>



                                <h4>Which Authentication Method Should You Use?</h4>
                                <p><strong>Password Authentication:</strong> Simple and easy for one-time manual use, but less secure and harder to manage at scale.</p>
                                <p><strong>SSH Key Authentication:</strong> More secure and ideal for automation. Keys can be protected with passphrases and rotated without changing server settings.</p>

                                <h4>Conclusion</h4>
                                <p>Connecting to an SFTP server in Python is straightforward with the help of the <code>paramiko</code> library. Whether you choose password or key-based authentication depends on your use case, but in general, SSH keys are more secure and flexible. Always ensure your connections are secure and your credentials are stored safely.</p>



                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <TrialBanner />

            <FooterOne footerLight />
        </Layout>
    );
};

export default HomeAppTwo;
